import { Tag } from 'antd';
import React, { ReactElement } from 'react';
import LoanDrawdownStatusEnum from '~Api/Loan/LoanDrawdownStatusEnum';
import { IDictionary } from '~utilities/IDictionary';
import loanDrawdownStatusLabels from './loanDrawdownStatusLabels';
import ILoanDrawdown from '~Api/Loan/ILoanDrawdown';

const loanDrawdownStatusClasses: IDictionary<string> = {
    [LoanDrawdownStatusEnum.Approved]: 'approved',
    [LoanDrawdownStatusEnum.DisbursalInstructed]: 'disbursal-instructed',
    [LoanDrawdownStatusEnum.PendingApproval]: 'pending-approval',
    [LoanDrawdownStatusEnum.Processed]: 'processed',
    [LoanDrawdownStatusEnum.QsInstructed]: 'qs-instructed',
    [LoanDrawdownStatusEnum.QsReceived]: 'qs-received',
    [LoanDrawdownStatusEnum.Requested]: 'requested',
};

export default function LoanDrawdownStatusTag(props: {
    loanDrawdown: ILoanDrawdown;
}): ReactElement {
    const { loanDrawdown } = props;

    return (
        <Tag
            className={`loan-drawdown-status ${loanDrawdownStatusClasses[loanDrawdown.status]}`}
        >{loanDrawdownStatusLabels[loanDrawdown.status]}</Tag>
    );
}